export const effortsConstants = {
    effortTypes: [
        {
            typeid: "member",
            name: "Member Drive",
            description:
                "Finding new members in your community. Membership recruitment can be done peer-to-peer, at events or in the community.",
            icon: "people",
        },
        {
            typeid: "phone",
            name: "Phone Canvass",
            description:
                "Reaching out to community members by phone to canvass or survey them.",
            icon: "call",
        },
        {
            typeid: "issue",
            name: "Follow-up request Gathering",
            description:
                "For gathering follow-up requests from community members. Follow-up requests can be assigned to team members for resolution. ",
            icon: "question_answer",
        },
        {
            typeid: "canvass",
            name: "Canvass",
            description:
                "To canvass community members directly through door knocking or at community events.",
            icon: "assignment",
        },
        {
            typeid: "volunteer",
            name: "Volunteer Drive",
            description:
                "Recruitment of new volunteers to this organization. Volunteer drives can be done peer-to-peer, at events or in the community.",
            icon: "insert_emoticon",
        },
        {
            typeid: "sales",
            name: "Switcher campaign",
            description:
                "Door-to-door campaign to switch customers from their current supplier.",
            icon: "home",
        },
        {
            typeid: "survey",
            name: "Survey",
            description:
                "Conducting a simple survey or vox pop with your community. Surveys can be conducted face-to-face at events, on doorsteps or in the community.",
            icon: "list",
        },
        {
            typeid: "donation",
            name: "Donation Drive",
            description:
                "Looking to find potential new donors for the organization. Donor recruitment can be managed peer-to-peer, at events or in the community.",
            icon: "monetization_on",
        },
        {
            typeid: "blank",
            name: "Blank Template",
            description: "Nothing suits? Start from scratch.",
            icon: "directions_walk",
        },
    ],
} as const;
